import style from "./ProgressBar.module.css"

/**
 * This element is a simple progress bar
 *
 * @param progress the progress expressed as a number between 0 and 1
 * @param children the text displayed on the bar
 * @returns {JSX.Element} the progress bar element
 * @constructor
 */
export const ProgressBar = ({ progress, children }) => {
    return (
        <div className={style.bar}>
            <span
                className={style.innerBar}
                style={{ width: `${progress * 100}%` }}
            />
            <span className={style.text}>{children}</span>
        </div>
    )
}
